import { ResourceModel } from '@bryntum/schedulerpro'

export function ordersSorter(item1: ResourceModel, item2: ResourceModel) {
  const orders1 = item1.getData('orders') as uui.domain.client.rm.SchedulerResource['orders']
  const orders2 = item2.getData('orders') as uui.domain.client.rm.SchedulerResource['orders']

  return orders1.current - orders2.current
}
